import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private sessionId: string | null = null;
  private token: string | null = null;
  private baseUrl: string = environment.Xano.Endpoint;
  private env: string = environment.Xano.Env;

  constructor(private httpClient: HttpClient) {}

  setSessionId(sessionId: string) {
    this.sessionId = sessionId;
  }

  setToken(token: string) {
    this.token = token;
  }

  getToken(): string | null {
    return this.token;
  }

  refreshToken(): Observable<any> {
    const url = this.getApiUrl('api:reheroesapis', 'bot_user/token/refresh');
    return this.httpClient.post(url, {
      token: this.token,
      session_id: this.sessionId,
    });
  }

  private getApiUrl(apiGroup: string, apiPath: string): string {
    let apiUrl = this.baseUrl;
    if (this.env) {
      apiUrl += `/${apiGroup}:${this.env}`;
    } else {
      apiUrl += `/${apiGroup}`;
    }
    apiUrl += `/${apiPath}`;
    return apiUrl;
  }
}
